const selectColorTypeImages: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#32346C",
    buttonColor: "#B15587",
  },
  {
    color: "#7992C1",
    buttonColor: "#70477E",
  },
  {
    color: "#751A0A",
    buttonColor: "#753C0A",
  },
  {
    color: "#020029",
    buttonColor: "#1F3537",
  },
  {
    color: "#332FD0",
    buttonColor: "#E73F76",
  },
  {
    color: "#E48958",
    buttonColor: "#000000",
  },
];

export default selectColorTypeImages;
